import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';


const NotFound = ({ objectType, children }) => (
  <div className='container' styleName='error-page'>
    <div className='jumbotron'>

      <h1>{ objectType } Not Found!</h1>

      { children }

    </div>
  </div>
);

NotFound.propTypes = {
  children: PropTypes.node,
  objectType: PropTypes.string,
};

NotFound.defaultProps = {
  children: null,
  objectType: 'Page',
};

export default NotFound;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/NotFound/index.jsx